import { AppRouter } from './router/AppRouter';

export const RecimetApp = () => {
  return (
    <>
      <AppRouter />
    </>
  );
};
